var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffad33;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.7,43.8c-.4-1-1.4-1.7-2.5-1.7h-32.1L73.6,6.1c.7-1.3.2-2.9-1.1-3.6-1-.5-2.1-.4-3,.4l-19.5,16.8L11.1,53.3c-1.1,1-1.2,2.6-.3,3.7.5.6,1.2.9,2,.9h32.1l-18.5,36c-.7,1.3-.2,2.9,1.1,3.6,1,.5,2.1.4,3-.4l19.5-16.8,38.9-33.6c.9-.7,1.2-1.9.8-2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.1ed913e6d3a01dd0ec267d3f9299b136.svg";
export { ForwardRef as ReactComponent };